import React, { useState } from "react";
import { applicationProcessData } from "../../config/homePageUtils";
import Image from "../common/Image";

const ApplicationProcess = ({ language }) => {
  const [activeTab, setActiveTab] = useState(
    applicationProcessData.tabs.find((tab) => tab.active)?.id,
  );

  return (
    <section className="max-w-7xl mx-auto px-4 py-12" id="ApplicationProcess">
      {/* Tabs */}
      <div
        className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 text-center top-tabs"
        id="tabs"
      >
        {applicationProcessData.tabs.map((tab) => (
          <div key={tab.id} className="relative inner-tabs">
            <button
              onClick={() => setActiveTab(tab.id)}
              id={`tabBtn-${tab.id}`}
              className={`tab-btn bg-[#018f9b] text-white px-4 py-6 rounded-lg shadow flex flex-col items-center justify-center h-full w-full transition ${
                activeTab === tab.id
                  ? "bg-[#018f9b] text-white"
                  : "bg-white border border-gray-300 text-black"
              }`}
            >
              <div className="text-2xl">
                <Image
                  src={tab.icon}
                  className={`icon-img ${tab.iconClasses} w-8 h-8 ${
                    activeTab === tab.id ? "invert" : ""
                  }`}
                />
              </div>
              <div
                className={`text-sm font-semibold mt-2 leading-tight ${
                  activeTab === tab.id ? "text-white" : "text-black"
                }`}
              >
                {(language ? tab.title.hi : tab.title.en)
                  .split("<br>")
                  .map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
              </div>
            </button>
            <div
              className={`arrow-down mt-[-4px] ${
                activeTab === tab.id ? "" : "hidden"
              }`}
              id={`arrow-${tab.id}`}
            ></div>
          </div>
        ))}
      </div>

      {/* Tab Content */}
      {applicationProcessData.tabs.map((tab) => {
        const ActiveComp = tab.description;
        const activeProps = tab.props ? { data: tab.props } : {};
        return (
          <div
            key={tab.id}
            id={tab.id}
            className={`tab-content ${
              activeTab === tab.id ? "block" : "hidden"
            }`}
          >
            <div className="bg-[#018f9b] text-white rounded-xl shadow-lg p-10 flex flex-col lg:flex-row items-center lg:items-start lg:items-center space-y-6 lg:space-y-0 lg:space-x-6 text-center lg:text-left">
              <div className="flex-1">
                <h2 className="text-2xl font-bold mb-3 text-white">
                  {language ? tab.title.hi : tab.title.en}
                </h2>
                <p className="mb-4 text-white">
                  <ActiveComp {...activeProps} />
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ApplicationProcess;
